import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { useTranslation } from "react-i18next";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const result = await login(email, password);
      if (result.needsVerification) {
        navigate("/verify");
      } else {
        navigate("/");
      }
    } catch (err) {
      setError(err.error || t("auth.loginFailed"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="h-full overflow-y-auto bg-th-bg">
    <div className="min-h-full flex flex-col items-center justify-center px-6 py-8">
      <img
        src={theme === "dark" ? "/pinned-logo-light-stacked.png" : "/pinned-logo-dark-stacked.png"}
        alt={t("app.title")}
        className="w-64 mb-3"
      />
      <p className="text-th-muted text-sm mb-8 text-center">
        {t("auth.tagline")}
      </p>

      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-3">
        {error && (
          <p className="text-sm text-th-danger bg-th-danger-bg border border-th-danger-border px-3 py-2 rounded-xl">
            {error}
          </p>
        )}
        <input
          type="email"
          placeholder={t("auth.email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full px-4 py-3.5 bg-th-surface border border-th-border rounded-xl text-base text-th-text placeholder-th-muted focus:outline-none focus:border-th-accent-border focus:ring-1 focus:ring-th-accent-border transition-all"
        />
        <input
          type="password"
          placeholder={t("auth.password")}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full px-4 py-3.5 bg-th-surface border border-th-border rounded-xl text-base text-th-text placeholder-th-muted focus:outline-none focus:border-th-accent-border focus:ring-1 focus:ring-th-accent-border transition-all"
        />
        <button
          type="submit"
          disabled={submitting}
          className="w-full py-3.5 bg-th-accent text-th-bg rounded-xl text-sm font-semibold disabled:opacity-50 hover:opacity-90 active:scale-[0.98] transition-all"
        >
          {submitting ? t("auth.loggingIn") : t("auth.login")}
        </button>
      </form>

      <p className="text-sm text-th-muted mt-4">
        <Link to="/forgot-password" className="text-th-accent font-medium">
          {t("forgot.forgotPassword")}
        </Link>
      </p>

      <p className="text-sm text-th-muted mt-3">
        {t("auth.noAccount")}{" "}
        <Link to="/register" className="text-th-accent font-medium">
          {t("auth.signup")}
        </Link>
      </p>
    </div>
    </div>
  );
}

export default LoginPage;
